import { makeAutoObservable } from "mobx";
import { User, UserBillingAddressFormValues, UserForgotPasswordValues, UserShippingAddressFormValues, 
    UserFormValues, LoginFormValues, ReportFormValues } from "../models/user";
import agent from "../api/agent";
import { store } from "./store";
import { runInAction } from "mobx";
import { toast } from 'react-toastify';
import { router } from "../router/Routes";

export default class UserStore {
    user: User | null = null;

    constructor() {
        makeAutoObservable(this);
    }

    get isLoggedIn() { return !!this.user}

    login = async (values: LoginFormValues) => {
        try {
            const user = await agent.Account.login(values);
            runInAction(() => {
                this.user = user;
            })
            store.commonStore.setToken(user.token);
            store.modalStore.closeModal();
            
            if (typeof user === "object")
                toast.success(`You are logged in successfully`);

            router.navigate(`${process.env.PUBLIC_URL}/permits`);
        } catch (error) {
            throw error;
        }
    }

    register = async (values: UserFormValues, isRedirect: boolean) => {
        try {
            const user = await agent.Account.register(values);
            // due to the not redirect issue
            runInAction(() => {
                this.user = user;
            })
            store.commonStore.setToken(user.token);
            store.modalStore.closeModal();
            
            if (isRedirect) {
                toast.success('Your WSF Account has been updated!');
                router.navigate(`${process.env.PUBLIC_URL}/permits`);
            }else {
                toast.success('New account has been created');
            }
        } catch (error) {
            throw error;
        }
    }

    updateShipping = async (values: UserShippingAddressFormValues, isRedirect: boolean) => {
        try {
            await agent.Account.updateShipping(values);
            this.getUser();
            
            store.modalStore.closeModal();
            toast.success('Shipping Information has been updated');

            if(isRedirect) {
                router.navigate(`${process.env.PUBLIC_URL}/permits`);
            }
            
        } catch (error) {
            throw error;
        }
    }

    setShippingSameInd = async () => {
        try {
            await agent.Account.setShipping();
            this.getUser();
            toast.success('Your WSF Account has been updated!');
            router.navigate(`${process.env.PUBLIC_URL}/permits`);
        } catch (error) {
            throw error;
        }
    }

    // dashboard -> Billing Address -> Edit button
    updateBilling = async (values: UserBillingAddressFormValues, isRedirect: boolean) => {
        try {
            await agent.Account.updateBilling(values);
            this.getUser();
            
            store.modalStore.closeModal();
            toast.success('Your WSF Account has been updated!');
            if (isRedirect) {
                router.navigate(`${process.env.PUBLIC_URL}/permits`);
            }
        } catch (error) {
            throw error;
        }
    }

    // dashboard -> Billing Address -> Use Primary Address! button
    setBillingSameInd = async () => {
        try {
            await agent.Account.setBilling();
            this.getUser();
            toast.success('Your WSF Account has been updated!');
            router.navigate(`${process.env.PUBLIC_URL}/permits`);
        } catch (error) {
            throw error;
        }
    }

    getUser = async () => {
        try {
            // get current user based on token passing
            const user = await agent.Account.current();
            runInAction(() => { this.user = user; })
        } catch (error) {
            // console.log(error);
        }
    }

    forgotPassword = async (values: UserForgotPasswordValues) => {
        try {
            await agent.Account.forgotPassword(values);
        } catch (error) {
            // console.log(error);
        } finally {
            toast.success(`Your password has been sent to the provided email. Please check your inbox. If you don't receive it soon, please verify the email or create a new account if needed.`);
        }
    }

    logout = () => {
        store.commonStore.setToken(null);
        this.user = null;

        // redirect to home page
        router.navigate(`${process.env.PUBLIC_URL}`);
    }

    reportIssue = async (values: ReportFormValues) => {
        try {
            await agent.Account.reportIssue(values);
            toast.success(`Thank you for your submission. Our customer service will contact you soon.`);

            agent.Emails.send("[Error] Permits Public Site - Customer sent message", "something went wrong while sending report message");

        } catch (error) {
            agent.Emails.send("[Error] Permits Public Site - Customer sent message", "something went wrong while sending report message");
        }
    }
}